import * as html2pdf from 'html2pdf.js';

export const ATTRIBUTE_TYPES = [
  { value: 'text', label: 'text' },
  { value: 'textarea', label: 'textarea' },
  { value: 'password', label: 'password' },
  { value: 'number', label: 'number' },
  { value: 'long', label: 'long' },
  { value: 'decimal', label: 'decimal' },
  { value: 'date', label: 'date' },
  { value: 'time', label: 'time' },
  { value: 'email', label: 'email' },
  { value: 'url', label: 'url' },
  { value: 'object', label: 'object' },
  { value: 'list', label: 'list' },
  { value: 'map', label: 'map' },
  { value: 'doc', label: 'doc' },
  { value: 'phone', label: 'phone' },
  { value: 'file', label: 'image' },
  { value: 'expression', label: 'expression' },
];

export const CHART_COLORS = [
  'rgba(45, 49, 66, 0.8)', // Dark blue-grey
  'rgba(75, 75, 109, 0.8)', // Dark indigo
  'rgba(29, 53, 87, 0.8)', // Dark navy
  'rgba(69, 123, 157, 0.8)', // Deep teal
  'rgba(230, 57, 70, 0.8)', // Dark red
  'rgba(168, 218, 220, 0.8)', // Muted teal
  'rgba(29, 105, 122, 0.8)', // Dark cyan
  'rgba(120, 66, 18, 0.8)', // Dark brown
  'rgba(50, 50, 50, 0.8)', // Dark grey
  'rgba(34, 40, 49, 0.8)', // Almost black
  'rgba(123, 31, 162, 0.8)', // Dark purple
  'rgba(67, 160, 71, 0.8)', // Dark green
  'rgba(255, 87, 34, 0.8)', // Dark orange
  'rgba(244, 81, 30, 0.8)', // Deep burnt orange
  'rgba(103, 58, 183, 0.8)', // Dark violet
];

export const generateColors = (count: number): string[] => {
  const colors = [];
  for (let i = 0; i < count; i++) {
    // Use colors from CHART_COLORS if available, else generate random colors
    if (i < CHART_COLORS.length) {
      colors.push(CHART_COLORS[i]);
    } else {
      const randomColor = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(
        Math.random() * 255
      )}, ${Math.floor(Math.random() * 255)}, 0.7)`;
      colors.push(randomColor);
    }
  }
  return colors;
};


export const getFilterLable = (label: string): string => {
  // Remove " id" (case-insensitive) from the end of the string
  label = label.replace(/ id$/i, '').trim();
  // If the label is already uppercase, return it as is
   // If the label is already uppercase, return it as is
   if (label === label.toUpperCase()) {
    return label;
  }

  // Capitalize the first letter of each word, preserving acronyms (e.g., "HIV")
  return label
    .split(' ') // Split into words
    .map(word =>
      word === word.toUpperCase() // Check if the word is an acronym
        ? word // Keep it as is
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize the first letter
    )
    .join(' '); // Rejoin words
};


export const alfaNumeric = (value: string): Boolean => {
  const regex = /^[a-zA-Z0-9]*$/; // Alphanumeric characters only
  return !regex.test(value);
}


export const getFilterAttributes = (attributeList: any, fields: any = null): any => {
  const allowedTypes = ['text', 'textarea', 'long', 'date', 'number', 'object', 'email', 'time', 'url', 'map', 'textarea', 'list', 'expression','file',
    'doc'];
  let result = attributeList.filter((attr: any) =>
    allowedTypes.includes(attr['type']) && attr['system'] !== 1
  );
  if (fields) {
    let fieldresult = result.map((attr: any) => {
      const field = fields.find((field: any) => field.id === attr.id);
      if (field && attr.depAttribute) {
        const depAttr = attributeList.find((item: any) => item.code === attr.depAttribute);
        return depAttr || attr;
      }
      return attr;
    });
    return fieldresult;
  }
  return result;
};



export const exportPdf = (self: any, name: string): any => {
  const element = self.content.nativeElement;
  const images = Array.from(element.getElementsByTagName('img')) as HTMLImageElement[];

 
  const promises = images.map((img) => {
    return new Promise<void>((resolve, reject) => {
      if (img.complete) {
        resolve();
      } else {
        img.onload = () => resolve();
        img.onerror = () => {
          console.error(`Error loading image: ${img.src}`);
          resolve();
        };
      }
    });
  });

  Promise.all(promises).then(() => {
    const options = {
      margin: [0.7, 0.4, 0.7, 0.4],
      filename: name + ".pdf",
      image: { type: 'jpeg', quality: 0.70 },
      html2canvas: {
        scale: 4,
        useCORS: true,
        logging: true,
        letterRendering: true,
      },
      jsPDF: {
        unit: 'in',
        format: 'a3',
        orientation: 'portrait',
        putOnlyUsedFonts: true,
      },
      pagebreak: { mode: ['css'] }
    };

    const exclude = document.querySelectorAll('.pdf-exclude');
    exclude.forEach((el: any) => el.style.display = 'none');

    html2pdf().from(element).set(options).toPdf().get('pdf').then((pdf: any) => {
      if (!pdf || !pdf.internal) {
        console.error("PDF internal object is undefined.");
        return;
      }

      let totalPages = pdf.internal.pages.length;
      let pageHeight = pdf.internal.pageSize.height || 16.50;
      let pageWidth = pdf.internal.pageSize.width || 11.69;

      const appName = self.usecase.appName;

      let keySuffix = self.locator.config.get('CONTEXT_PATH') + '-';
      let usercontextString = localStorage.getItem(keySuffix + "userContext");

      let orgLogoId = 0;
      let orgName = " ";

      if (usercontextString !== null) {
        try {
          let usercontext = JSON.parse(usercontextString);
          orgLogoId = usercontext.orgLogoId || 0;
          orgName = usercontext.orgName || "";
        } catch (error) {
          console.error("Error parsing usercontext:", error);
        }
      } else {
        orgLogoId = 0;
        orgName = "";
      }

      const footerText1 = orgName;

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(20);
        pdf.text(appName, 0.5, 0.3);

        if (orgLogoId != 0) {
          const logoSrc = self.getDoc(orgLogoId);
          if (logoSrc) {
            pdf.addImage(logoSrc, 'PNG', pageWidth - 2.0, 0.1, 0.5, 0.5);
          }
        }

        pdf.setFontSize(16);
        pdf.text(footerText1, 0.5, pageHeight - 0.32);


        // Adding page number to the footer
        const pageNumber = `Page No ${i}`;
        pdf.setFontSize(14);
        pdf.text(pageNumber, pageWidth - 6.0, pageHeight - 0.3); // Position of page numbe

        const footerText2 = "Powered By";
        pdf.setFontSize(16);
        pdf.text(footerText2, pageWidth - 2.9, pageHeight - 0.35);

        const imageSrc = 'assets/images/ncs.png';
        if (imageSrc) {
          pdf.addImage(imageSrc, 'PNG', pageWidth - 1.5, pageHeight - 0.6, 0.8, 0.4);
        }
      }

      pdf.save(name + '.pdf');

      exclude.forEach((el: any) => el.style.display = '');
    }).catch((error: any) => {
      console.error('Error generating PDF:', error);
    });
  }).catch((error) => {
    console.error('Error loading images:', error);
  });
};

export const getInputType = (t: any): any => {
 switch (t) {
    case 'date':
     return 'date';
    case 'idate':
      return 'date';
    case 'number':
    case 'decimal':
    return 'number';
    case 'text':
    return 'text';
    case 'time':
      return 'time';
    case 'file':
      return 'file';
    case 'textarea':
      return 'text';
    case 'dateandtime':
      return 'datetime-local';
    case 'password':
     return 'password';
     case 'itime':
      return 'time';    
    default:
    return 'text';
  }
};
